module.exports = "/_next/static/images/VGBExampleImage2-1a12cc4530a433f29ded6f7a5e18e54d.png";